{
  "id": "campaign-008",
  "name": "Sleepy Corner",
  "seed": "campaign:8",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "...#.....",
    ".........",
    "......T..",
    ".........",
    ".........",
    ".........",
    "T.....**.",
    "......*..",
    "...B.....",
    "........S"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 6,
      "y": 3
    }
  ],
  "pickups": [
    {
      "kind": "coin",
      "x": 6,
      "y": 0
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 5
    },
    {
      "kind": "rare",
      "x": 0,
      "y": 0
    }
  ],
  "generatorVersion": 3,
  "level": 8,
  "biome": "backyard",
  "par": {
    "reel": 2910,
    "push": 2522,
    "selfPropelled": 2400,
    "tractor": 2080,
    "zeroTurn": 1615,
    "fairway": 924
  },
  "routeTries": {
    "par": {
      "reel": 4,
      "push": 1,
      "selfPropelled": 10,
      "tractor": 0,
      "zeroTurn": 7,
      "fairway": 24
    }
  }
}
